import React from "react";

const Title = () => {
  return <>Vouchers SAP</>;
};

export default Title;
